import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { SiteDto } from '../../dtos';
import { useFailedCreateSnackbar, useSuccessfulCreateSnackbar } from '../../Components/CoreLib/library';
import { useCreateSiteMutation } from '../../store/generated/generatedApi';
import { SiteForm } from '../../Components/Forms/SiteForm';

export const AddSiteView: FC = () => {
    const navigate = useNavigate();
    const [createSite, { isError, error, isSuccess, reset }] = useCreateSiteMutation();

    useSuccessfulCreateSnackbar('Site', isSuccess, reset);
    useFailedCreateSnackbar('site', isError, reset, error);

    const handleSave = async (values: SiteDto) => {
        return await createSite(values).unwrap();
    };

    const handleCancel = () => {
        navigate('/dataManagement/sites');
    };

    const handleAfterSuccessfulCreate = useCallback(
        (site: SiteDto) => {
            navigate(`/dataManagement/site/${site.id}`);
        },
        [navigate]
    );

    return (
        <SiteForm save={handleSave} cancel={handleCancel} onAfterSuccessfulCreate={handleAfterSuccessfulCreate} />
    );
};
